import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props.bgColor || "#F3FAF6"} />
    <G clipPath="url(#clip0_997_4607)">
      <Path
        opacity={0.2}
        d="M13.9561 28.7337H10.9201C10.7188 28.7337 10.5258 28.6537 10.3834 28.5114C10.2411 28.369 10.1611 28.176 10.1611 27.9747V24.1798C10.1611 23.9785 10.2411 23.7854 10.3834 23.6431C10.5258 23.5007 10.7188 23.4208 10.9201 23.4208H13.9561V28.7337Z"
        fill={props.color || "#0E8741"}
      />
      <Path
        opacity={0.2}
        d="M28.756 14.3127C28.3622 14.313 27.9733 14.4008 27.6176 14.5698C27.5917 14.0001 27.3832 13.4538 27.0229 13.0117C26.6625 12.5696 26.1695 12.2553 25.6166 12.1151C25.0638 11.975 24.4805 12.0165 23.9531 12.2335C23.4256 12.4505 22.982 12.8315 22.6879 13.3201C22.3938 13.8088 22.2647 14.3791 22.3198 14.9468C22.3749 15.5144 22.6112 16.0493 22.9938 16.4722C23.3764 16.8952 23.885 17.1838 24.4443 17.2953C25.0036 17.4068 25.584 17.3354 26.0996 17.0916C26.1235 17.6111 26.2995 18.1121 26.6055 18.5326C26.9116 18.9531 27.3344 19.2744 27.8214 19.4568C28.3084 19.6393 28.8383 19.6747 29.3453 19.5588C29.8522 19.4429 30.3141 19.1807 30.6734 18.8048C31.0328 18.4289 31.2739 17.9557 31.3669 17.4441C31.4599 16.9324 31.4006 16.4046 31.1964 15.9263C30.9923 15.448 30.6522 15.0402 30.2184 14.7533C29.7846 14.4665 29.2761 14.3133 28.756 14.3127Z"
        fill={props.color || "#0E8741"}
      />
      <Path
        d="M28.7563 19.6258C30.2234 19.6258 31.4128 18.4364 31.4128 16.9693C31.4128 15.5022 30.2234 14.3129 28.7563 14.3129C27.2892 14.3129 26.0999 15.5022 26.0999 16.9693C26.0999 18.4364 27.2892 19.6258 28.7563 19.6258Z"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.51797}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.9561 28.7337H10.9201C10.7188 28.7337 10.5258 28.6537 10.3834 28.5114C10.2411 28.369 10.1611 28.176 10.1611 27.9747V24.1798C10.1611 23.9785 10.2411 23.7854 10.3834 23.6431C10.5258 23.5007 10.7188 23.4208 10.9201 23.4208H13.9561"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.51797}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.028 24.1797H23.0639L29.4204 22.7177C29.6541 22.6537 29.8994 22.6444 30.1373 22.6906C30.3752 22.7368 30.5992 22.8372 30.792 22.984C30.9847 23.1309 31.141 23.3202 31.2487 23.5373C31.3563 23.7544 31.4125 23.9934 31.4128 24.2357C31.4129 24.5283 31.3315 24.8151 31.1776 25.0639C31.0238 25.3128 30.8036 25.5139 30.5418 25.6446L26.8588 27.2157L20.7869 28.7336H13.9561V23.4207L16.3279 21.0489C16.5399 20.8376 16.7915 20.6702 17.0682 20.5563C17.345 20.4423 17.6414 20.384 17.9407 20.3848H22.6844C23.1877 20.3848 23.6703 20.5847 24.0261 20.9405C24.382 21.2964 24.5819 21.779 24.5819 22.2822C24.5819 22.7855 24.382 23.2681 24.0261 23.624C23.6703 23.9798 23.1877 24.1797 22.6844 24.1797H20.028Z"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.51797}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M26.0996 17.0916C25.584 17.3354 25.0036 17.4068 24.4443 17.2953C23.885 17.1838 23.3764 16.8952 22.9938 16.4722C22.6112 16.0493 22.3749 15.5144 22.3198 14.9468C22.2647 14.3791 22.3938 13.8088 22.6879 13.3201C22.982 12.8315 23.4256 12.4505 23.9531 12.2335C24.4805 12.0165 25.0638 11.975 25.6166 12.1151C26.1695 12.2553 26.6625 12.5696 27.0229 13.0117C27.3832 13.4538 27.5917 14.0001 27.6176 14.5698"
        stroke={props.color || "#0E8741"}
        strokeWidth={1.51797}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_4607">
        <Rect
          width={24.2876}
          height={24.2876}
          fill="white"
          transform="translate(9.40234 9)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
